import React from "react"
import { Button, Typography, Container, Box } from "@mui/material"
import { useNavigate } from "react-router-dom"

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "2rem",
        }}
      >
        <Typography component="h1" variant="h4">
          404 - Page Not Found
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/")}
        >
          Go back to homepage
        </Button>
      </Box>
    </Container>
  )
}

export default NotFoundPage
